(function(){
  var WKZ_BASE=(document.currentScript&&document.currentScript.src)||'';
  var ICONS={
    truck:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><rect x="1" y="6" width="13" height="10" rx="1"/><path d="M14 9h4l3 3v4h-7z"/><circle cx="6" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>',
    pin:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M12 22s7-6.4 7-12a7 7 0 10-14 0c0 5.6 7 12 7 12z"/><circle cx="12" cy="10" r="2.6"/></svg>',
    whatsapp:'<svg viewBox="0 0 32 32" fill="currentColor"><path d="M16 3.2A12.8 12.8 0 005.1 22.5L3.2 28.8l6.5-1.7A12.8 12.8 0 1016 3.2zm0 23.3a10.4 10.4 0 01-5.3-1.5l-.4-.2-3.9 1 1-3.8-.2-.4A10.5 10.5 0 1116 26.5zm5.8-7.8c-.3-.2-1.9-.9-2.1-1-.3-.1-.5-.2-.7.2s-.8.9-.9 1.1-.4.2-.7 0a8.6 8.6 0 01-2.5-1.6 9.5 9.5 0 01-1.8-2.2c-.2-.3 0-.5.1-.6l.5-.6.3-.5c.1-.2 0-.4 0-.5l-1-2.3c-.2-.6-.5-.5-.7-.5h-.6a1.1 1.1 0 00-.8.4 3.3 3.3 0 00-1 2.5 5.7 5.7 0 001.2 3 13 13 0 005 4.4c2.9 1.1 2.9.8 3.4.7a3 3 0 002-1.4 2.4 2.4 0 00.2-1.4c-.1-.1-.3-.2-.6-.3z"/></svg>',
    headset:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M4 13v-1a8 8 0 0116 0v1"/><rect x="2.5" y="13" width="4" height="6" rx="1"/><rect x="17.5" y="13" width="4" height="6" rx="1"/><path d="M20 19a4 4 0 01-4 4h-2"/></svg>'
  };
  function esc(s){return (s==null?'':String(s)).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function buildSwiper(slides){
    var s='<div class="wkz-bs"><div class="wkz-bs__track">';
    slides.forEach(function(b){
      var ext=/^https?:/.test(b.url||'')?' target="_blank" rel="noopener"':'';
      s+='<a class="wkz-bs__slide" href="'+esc(b.url||'#')+'"'+ext+'>'
        +'<img src="'+esc(b.img)+'" alt="'+esc(b.title||'')+'" loading="lazy">'
        +'<span class="wkz-bs__ov">'
        +(b.eyebrow?'<span class="wkz-bs__ey">'+esc(b.eyebrow)+'</span>':'')
        +(b.title?'<span class="wkz-bs__ti">'+esc(b.title)+'</span>':'')
        +(b.cta?'<span class="wkz-bs__cta">'+esc(b.cta)+'</span>':'')
        +'</span></a>';
    });
    s+='</div><div class="wkz-bs__dots">';
    slides.forEach(function(_,i){ s+='<span class="wkz-bs__dot'+(i===0?' is-active':'')+'" data-i="'+i+'"></span>'; });
    s+='</div></div>';
    return s;
  }
  function initSwiper(el){
    if(!el||el.__init)return; el.__init=true;
    var track=el.querySelector('.wkz-bs__track');
    var dots=[].slice.call(el.querySelectorAll('.wkz-bs__dot'));
    var n=dots.length, i=0, timer=null, sx=0, dx=0, drag=false;
    function go(k){ i=(k+n)%n; track.style.transform='translateX('+(-i*100)+'%)'; dots.forEach(function(d,j){d.classList.toggle('is-active',j===i);}); }
    function play(){ stop(); if(n>1) timer=setInterval(function(){go(i+1);},4500); }
    function stop(){ if(timer){clearInterval(timer);timer=null;} }
    dots.forEach(function(d){ d.addEventListener('click',function(){ go(+d.getAttribute('data-i')); play(); }); });
    track.addEventListener('touchstart',function(e){ drag=true; sx=e.touches[0].clientX; dx=0; stop(); },{passive:true});
    track.addEventListener('touchmove',function(e){ if(drag) dx=e.touches[0].clientX-sx; },{passive:true});
    track.addEventListener('touchend',function(){ if(drag){ if(Math.abs(dx)>40) go(i+(dx<0?1:-1)); drag=false; play(); } });
    go(0); play();
  }
  function init(){
    var d=document.getElementById('mobile-drawer')||document.querySelector('.mobile-drawer');
    if(!d||d.__wkzEnh)return; d.__wkzEnh=true;
    var cfg=window.WKZ_DRAWER||{};
    var footer=d.querySelector('.mob-drawer-footer');
    var socials=d.querySelector('.mob-drawer-socials');
    /* WKZ EDIT: quicklinks used to always be inserted inside .mob-drawer-footer
       (via footer.insertBefore(ql, socials)), which assumed .mob-drawer-socials
       lived inside the footer. The socials row now renders as a sibling directly
       below the promo banner (outside the footer), so we insert relative to
       whatever socials' actual parent is instead of assuming it's the footer. */
    var qlHost = (socials && socials.parentNode) || footer || d.querySelector('.mob-drawer__inner');
    if(qlHost&&cfg.quicklinks&&cfg.quicklinks.length&&!d.querySelector('.wkz-ql')){
      var ql=document.createElement('div'); ql.className='wkz-ql';
      cfg.quicklinks.forEach(function(q){
        var a=document.createElement('a'); a.className='wkz-ql__item'; a.href=q.url||'#';
        if(/^https?:/.test(q.url||'')){a.target='_blank';a.rel='noopener';}
        a.innerHTML='<span class="wkz-ql__ic">'+(ICONS[q.icon]||ICONS.pin)+'</span><span>'+esc(q.label)+'</span>';
        ql.appendChild(a);
      });
      if(socials&&socials.parentNode){ socials.parentNode.insertBefore(ql, socials); }
      else if(footer){ footer.insertBefore(ql, footer.firstChild); }
      else { qlHost.appendChild(ql); }
    }
    var slides=(cfg.banners||[]).filter(function(b){return b&&b.img;});
    if(slides.length){
      var host=d.querySelector('.mob-promo-center');
      if(!host){ host=document.createElement('div'); host.className='mob-promo-center';
        if(footer){ footer.parentNode.insertBefore(host,footer); } else { d.appendChild(host); } }
      if(!host.querySelector('.wkz-bs')){ host.innerHTML=buildSwiper(slides); initSwiper(host.querySelector('.wkz-bs')); }
    }
    if(footer&&cfg.wishlist&&!footer.querySelector('.wkz-wish')){
      var w=document.createElement('a'); w.className='mob-drawer-login wkz-wish'; w.href=cfg.wishlist;
      w.innerHTML='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.8 5.6a5.5 5.5 0 00-7.8 0L12 6.6l-1-1a5.5 5.5 0 10-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 000-7.8z"/></svg><span>Wishlist</span>';
      var login=footer.querySelector('.mob-drawer-login:not(.wkz-wish)');
      if(login&&login.nextSibling){ footer.insertBefore(w,login.nextSibling); } else { footer.appendChild(w); }
    }
  }
  if(document.readyState!=='loading'){init();} else {document.addEventListener('DOMContentLoaded',init);}
  document.addEventListener('click',function(){ setTimeout(init,60); },true);
  try{ if(WKZ_BASE){
    var base=WKZ_BASE.split('?')[0], bust='?v='+Date.now();
    var c=document.createElement('link'); c.rel='stylesheet'; c.href=base.replace('wkz-enhance.js','wkz-search.css')+bust; document.head.appendChild(c);
    var j=document.createElement('script'); j.src=base.replace('wkz-enhance.js','wkz-search.js')+bust; document.head.appendChild(j);
  } }catch(e){}
})();
/* Product page: clicking a color leads the gallery with that color's first photo (all products, colors only). */
(function () {
  function pathOf(img) {
    try { return new URL(img.getAttribute('src') || '', location.href).pathname; }
    catch (e) { return ''; }
  }
  function lead() {
    var gallery = document.querySelector('.wkz-product-gallery');
    if (!gallery) return;
    var sel = document.querySelector('input[name="wkz-color"]:checked');
    if (!sel) return;
    var label = sel.nextElementSibling;
    var swatch = label && label.querySelector ? label.querySelector('img') : null;
    if (!swatch) return; /* this color has no photo (plain dot swatch) */
    var key = pathOf(swatch);
    if (!key) return;
    if (!gallery.__wkzOrig) gallery.__wkzOrig = [].slice.call(gallery.querySelectorAll('img'));
    var imgs = gallery.__wkzOrig, match = null;
    for (var i = 0; i < imgs.length; i++) { if (pathOf(imgs[i]) === key) { match = imgs[i]; break; } }
    if (!match) return;
    try { match.loading = 'eager'; } catch (e) {}
    var ordered = [match];
    for (var j = 0; j < imgs.length; j++) { if (imgs[j] !== match) ordered.push(imgs[j]); }
    ordered.forEach(function (im) { gallery.appendChild(im); });
    try { gallery.scrollLeft = 0; } catch (e) {}
  }
  function bind() {
    var gallery = document.querySelector('.wkz-product-gallery');
    if (!gallery || gallery.__wkzColorBound) return;
    var colors = document.querySelectorAll('input[name="wkz-color"]');
    if (!colors.length) return;
    gallery.__wkzColorBound = true;
    [].forEach.call(colors, function (r) { r.addEventListener('change', lead); });
    lead();
  }
  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);
})();

/* Mobile sticky header: add html.wkz-scrolled once the page is scrolled, so the CSS can fill the header with colour. */
(function(){
  var root=document.documentElement, t=10, ticking=false;
  function apply(){ ticking=false; var y=window.pageYOffset||document.documentElement.scrollTop||0; root.classList.toggle('wkz-scrolled', y>t); }
  function onScroll(){ if(!ticking){ ticking=true; window.requestAnimationFrame(apply); } }
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll,{passive:true});
  if(document.readyState!=='loading'){ apply(); } else { document.addEventListener('DOMContentLoaded',apply); }
})();